export abstract class EventData
{
    constructor(public TimeStamp: Date)
    {
    }
}

export class CyclingPowerEventData extends EventData {
    constructor(public TimeStamp: Date) {
        super(TimeStamp);
    }

    public Power: number = 0;
    public CrankRpm: number = 0;
    public WheelRpm: number = 0;

    public static Create(power: number, crankRpm: number, wheelRpm: number): CyclingPowerEventData {
        var data = new CyclingPowerEventData(new Date());
        data.Power = power;
        data.CrankRpm = crankRpm;
        data.WheelRpm = wheelRpm;

        return data;
    }
}
